<script>
import { SCROLL_OPTIONS } from '@d-shared/config';

export default {
  props: {
    shouldScroll: {
      type: Boolean,
      default: false,
    },
    initTab: {
      type: String,
      default: null,
    },
    alwaysVisible: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    currentTab: null,
  }),
  async mounted() {
    const hashTabId = document.location.hash.slice(1);
    const isExcludedHash = this.alwaysVisible === hashTabId;

    if (this.initTab && (!hashTabId || isExcludedHash)) {
      await this.toggleTab(this.initTab);
    }

    if (isExcludedHash) {
      this.scrollToTab(hashTabId);
      return;
    }

    if (hashTabId) await this.toggleTab(hashTabId);
  },
  methods: {
    async toggleTab(tab, shouldScroll = false) {
      this.$set(this, 'currentTab', tab);
      const tabId = `#${tab}`;

      this.updateUrlHash(tabId);

      if (!shouldScroll) return;

      await this.$nextTick();
      this.scrollToTab(tab);
    },
    scrollToTab(tabId) {
      const scrollOptions = Object.assign({}, SCROLL_OPTIONS);
      scrollOptions.offset = -88;

      this.$scrollTo(`[data-id="${tabId}"]`, scrollOptions);
      this.updateUrlHash(`#${tabId}`);
    },
    updateUrlHash(tabId) {
      history.replaceState({}, '', tabId);
    },
    isActive(tab) {
      return tab === this.currentTab;
    },
  },
  render: function (createElement) {
    return createElement('div', [
      this.$scopedSlots.default({
        currentTab: this.currentTab,
        toggleTab: this.toggleTab,
        scrollToTab: this.scrollToTab,
        isActive: this.isActive,
      }),
    ]);
  },
};
</script>

<style lang="scss" scoped></style>
